import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/models/table-column.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
    selector: 'app-compliance-course-qualification-status-widget',
    templateUrl: './compliance-course-qualification-status-widget.component.html',
    styleUrl: './compliance-course-qualification-status-widget.component.scss',
    standalone: false
})
export class ComplianceCourseQualificationStatusWidgetComponent {
  complianceCoursesQualificationData: any[] = [];

  complianceCoursesQualificationColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS') + ' %',
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentage',
      calculateDisplayValue: (data: any): string => {
        return data.progressPercentage + ' %';
      },
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS-BAR'),
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentageBar',
      cellTemplate: 'progressBullet',
      disableFiltering: true,
    },
  ];

  constructor(
    private dashboardWidgetsDataService: DashboardWidgetsDataService,
    private translateService: TranslateService,
    private router: Router
  ) {
    
  }
  
  ngOnInit() {
    this.dashboardWidgetsDataService.getTrainingGroupsProgress().subscribe(data => {
    if (data) {
      this.complianceCoursesQualificationData = data
        .map((data, index) => {
          return {
            id: data.id,
            name: data.name,
            progress: `${data.numberOfPersonsCompleted} / ${
              data.numberOfPersonsOpen + data.numberOfPersonsCompleted
            }`,
            progressPercentage:
              data.numberOfPersonsOpen + data.numberOfPersonsCompleted > 0
                ? Math.min(
                    Math.round(
                      (data.numberOfPersonsCompleted /
                        (data.numberOfPersonsOpen +
                          data.numberOfPersonsCompleted)) *
                        100
                    ),
                    100
                  )
                : 0,
          };
        })
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    });
  }

  onCourseClick(event: any) {
    this.router.navigate(['/manage-elearning/' + event]);
  }
}
